import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";
import { useLang } from "@/lib/i18n";

export const Footer = () => {
  const { t, to } = useLang();
  return (
    <footer className="bg-navy text-cream" data-testid="site-footer">
      <div className="container-x py-14 sm:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="block h-2.5 w-2.5 rounded-sm bg-coral" />
              <span className="text-base font-bold tracking-tight">{SITE.name}</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-cream/70">{t.footer.blurb}</p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-cream/50">{t.footer.contact}</p>
            <address className="mt-4 text-sm not-italic leading-relaxed text-cream/80" data-testid="footer-address">
              {SITE.address.map((line) => (
                <span key={line} className="block">{line}</span>
              ))}
            </address>
            <a
              href={`mailto:${SITE.email}`}
              className="link-underline mt-4 inline-block text-sm font-medium text-cream"
              data-testid="footer-email"
            >
              {SITE.email}
            </a>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-cream/50">{t.footer.legal}</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to={to("/privacy")} className="link-underline text-cream" data-testid="footer-link-privacy">
                  {t.footer.privacy}
                </Link>
              </li>
              <li>
                <Link to={to("/terms")} className="link-underline text-cream" data-testid="footer-link-terms">
                  {t.footer.terms}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-cream/15 pt-8">
          <p className="text-xs text-cream/70" data-testid="footer-copyright">
            {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};
